import axios from 'axios';

// LangChain AI Hub base URL - Uses environment variables
// Falls back to BACKEND_URL (Gateway) if LANGCHAIN_AI_HUB_BASE_URL not set
const LANGCHAIN_AI_HUB_BASE_URL = process.env.REACT_APP_LANGCHAIN_AI_HUB_BASE_URL || process.env.REACT_APP_BACKEND_URL || '';
const PDF_API_BASE_URL = `${LANGCHAIN_AI_HUB_BASE_URL}langchain`;

// Create axios instance with default config
const pdfApi = axios.create({
  baseURL: PDF_API_BASE_URL,
  timeout: 300000, // 5 minutes for large file uploads
});

// Add request interceptor to include auth headers
pdfApi.interceptors.request.use(
  (config) => {
    // Add JWT token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Add tenant ID header
    const tenantId = localStorage.getItem('tenantId');
    if (tenantId) {
      config.headers['X-Tenant-Id'] = tenantId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
pdfApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('PDF API Error:', error);
    return Promise.reject(error);
  }
);

// PDF API methods
export const pdfApiService = {
  // Upload PDF file
  upload: (formData, onUploadProgress) => {
    return pdfApi.post('/pdf-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onUploadProgress(percentCompleted);
        }
      },
    });
  },

  // List all PDF files
  listFiles: () => {
    return pdfApi.get('/pdf-files');
  },

  // Get presigned URL for viewing/downloading a file
  getFileUrl: (fileKey, expiresIn = 3600) => {
    return pdfApi.get(`/pdf-files/${encodeURIComponent(fileKey)}/url`, {
      params: { expires_in: expiresIn },
    });
  },
};

export default pdfApi;

